import { getIntl } from '@ackee/jerome/antd';
import message from 'antd/lib/message';
import { getFirebase } from 'react-redux-firebase';
import { getFirestore } from 'redux-firestore';
import { startSubmit, stopSubmit } from 'redux-form';
import * as sagaEffects from 'redux-saga/effects';

import config from 'config/index';
import * as loglevel from 'config/loglevel';

import { getPartnersValueKey } from '../../utils';
import types from '../actionTypes';

const { takeEvery, put } = sagaEffects;

function* handler({ payload, meta }) {
    const firestore = getFirestore(getFirebase());
    const intl = yield getIntl();

    yield put(startSubmit(meta.form));
    try {
        for (const lang of config.app.languages) {
            const ref = yield firestore.doc(`languages/${lang}/eventProperties/partners`);
            yield ref.set({ value: payload[getPartnersValueKey(lang)] });
        }
        yield put(stopSubmit(meta.form));
        message.success(intl.formatMessage({ id: 'success.partners.update' }));
    } catch (e) {
        yield put(stopSubmit(meta.form, { _error: 'errors.partners.update' }));
        loglevel.error(e);
    }
}

export default function* () {
    yield takeEvery(types.UPDATE_PARTNERS_REQUEST, handler);
}
